<template>
  <div :class="$style.wrapper">
    <b-img
      :src="image"
      fluid-grow
      :class="$style.image"
    />
    <span
      :class="$style.text"
      class="pt-3"
    >
      {{ name[$i18n.locale] || name['en'] }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'BaseTeamWrapper',
  props: {
    image: {
      type: String,
      required: true,
      default: null,
    },
    name: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style module lang="scss">
  @import "../../../assets/scss/variables";
  .wrapper {
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;
  }
  .image {
    max-width: 150px !important;
  }
  .text {
    color: $color-midnight-blue;
    font-weight: 600;
    font-size: $font-size-small;
    text-transform: uppercase;
  }
</style>
